module.exports = __webpack_public_path__ + "img/prime.23970c3b.png";